import { ShiftTypeEnum } from '../../../../api';
import { EPresetTime, IShiftPreset } from '../ShiftPreset';
import AllDayIcon from '../ShiftPreset/Icons/allDay';
import DayIcon from '../ShiftPreset/Icons/day';
import NightIcon from '../ShiftPreset/Icons/night';

export const providerPresets: IShiftPreset[] = [
  {
    label: 'Daytime',
    type: ShiftTypeEnum.DAYTIME,
    tooltip:
      'Selecting “Daytime” allows a healthcare organization to send a shift request that takes place during the day but does not cross midnight. You have the option to approve, decline, or modify the shift once the request is sent to you.',
    icon: <DayIcon className="preset-icon" />,
    providerPresetFieldName: 'hourly_day_rate',
    timePeriod: EPresetTime.DAYSHIFT,
  },
  {
    label: 'Overnight',
    type: ShiftTypeEnum.OVERNIGHT,
    tooltip:
      'Selecting “Overnight” will require that the healthcare organization only book you for a shift that crosses midnight (aka a “Night Shift”). You have the option to approve, decline, or modify the shift once the request is sent to you.',
    icon: <NightIcon className="preset-icon" />,
    providerPresetFieldName: 'hourly_night_rate',
    timePeriod: EPresetTime.NIGHTSHIFT,
  },
  {
    label: 'Anytime',
    type: ShiftTypeEnum.ANYTIME,
    tooltip:
      'Selecting "Anytime" allows a healthcare organization to send a shift request that can start at any point during the day and can be either a day shift or a night shift. You have the option to approve, decline, or modify the shift once the request is sent to you.',
    icon: <AllDayIcon className="preset-icon" />,
    providerPresetFieldName: 'hourly_24h_rate',
    timePeriod: EPresetTime.FULLDAYSHIFT,
  },
];

export const AVAILABILITY_DAY_FORMAT = 'MM/dd/yyyy';
